import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-password-meter",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./password-meter.component.html",
  styleUrls: ["./password-meter.component.scss"],
})
export class PasswordMeterComponent implements OnChanges {
  @Input() password: string;
  @Input() hiddenRules: boolean = true;

  public passwordValue: string;
  public passwordAllow: boolean;

  @Output() buttonPassword = new EventEmitter<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    var passwordVerify = changes["password"].currentValue;
    this.passwordValue = passwordVerify;
    if (passwordVerify) {
      this.checkPasswordStrength();
      this.passwordAllow == true
        ? this.buttonPassword.emit(true)
        : this.buttonPassword.emit(false);
    }
  }

  public passwordStrength: any = {};
  public missingPasswordRule: any = [];
  public allowPassword: boolean = false;

  public checkPasswordStrength() {
    this.passwordAllow = false;
    let score = 1;
    this.missingPasswordRule = [];
    if (this.passwordValue.length == 0 && !this.passwordValue) {
      score = 1;
      this.missingPasswordRule.push(
        "A senha deve ter pelo menos um caractere especial.",
        "A senha deve ter pelo menos um caractere numérico.",
        "A senha deve ter pelo menos um caractere com letra maiúscula.",
        "A senha deve ter pelo menos um caractere com letra minúscula.",
        "A senha não deve ter uma sequência com mais de 2 caracteres iguais.",
        "A senha deve ter o tamanho mínimo de 8 e no máximo 15 caracteres."
      );
    }
    if (this.passwordValue) {
      // validação de caracteres especiais:
      if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.passwordValue)) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha deve ter pelo menos um caractere especial."
        );
      }

      // validação de números:
      if (/\d/.test(this.passwordValue)) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha deve ter pelo menos um caractere numérico."
        );
      }

      // validação de letras maiúsculas:
      if (/[A-Z]/.test(this.passwordValue)) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha deve ter pelo menos um caractere com letra maiúscula."
        );
      }

      // validação de letras minúsculas:
      if (/[a-z]/.test(this.passwordValue)) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha deve ter pelo menos um caractere com letra minúscula."
        );
      }

      // validação de senha sequencial:
      if (!/(.)\1\1/.test(this.passwordValue)) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha não deve ter uma sequência com mais de 3 caracteres iguais."
        );
      }

      // validação de tamanho mínimo de 8 caracteres:
      if (this.passwordValue.length >= 8 && this.passwordValue.length <= 15) {
        score++;
      } else {
        score--;
        this.missingPasswordRule.push(
          "A senha deve ter o tamanho mínimo de 8 e no máximo 15 caracteres."
        );
      }
    }
    if (score === 1) {
      this.passwordStrength = {};
    } else if (score === 2) {
      this.passwordStrength = {
        text: "Muito fraca",
        percent: 16.66,
        color: "warn",
      };
    } else if (score === 3) {
      this.passwordStrength = { text: "Fraca", percent: 32.32, color: "warn" };
    } else if (score === 4) {
      this.passwordStrength = { text: "Média", percent: 49.98, color: "alert" };
    } else if (score === 5) {
      this.passwordStrength = {
        text: "Forte",
        percent: 66.64,
        color: "success",
      };
    } else if (score === 6) {
      this.passwordStrength = {
        text: "Muito forte",
        percent: 83.3,
        color: "success",
      };
    } else if (score === 7) {
      this.passwordStrength = {
        text: "Excelente",
        percent: 100,
        color: "success",
      };
      this.passwordAllow = true;
    }
  }
}
